<template>
  <div class="about-container">
    <div class="about-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem>用户服务协议</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="about-detail">
          <div class="about-detail-cont">
            <div class="about-detail-item">用户服务协议</div>
            <div class="detail-cont" v-html="detailInfo.content"></div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">用户服务协议</div>
            <div class="enname">Agreement</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHeaderData, getAgreementData } from '../../api/getData.js'
export default {
  name: 'agreement',
  data () {
    return {
      headerInfo: {},
      detailInfo: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.getHeaderInfo()
      this.getAgreementInfo()
    }
  },
  created () {
    this.getHeaderInfo()
    this.getAgreementInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'agreement', activeSendMenu: '' }).then(() => {}).catch(() => {})
    },
    async getAgreementInfo () {
      let result = await getAgreementData()
      this.detailInfo = result.info
    }
  }
}
</script>

<style scoped lang="less">
  .about-container_{
    padding-bottom: 60px;
  }
  .about-detail{
    width: 77.22%;
    padding: 0 66px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .about-detail-cont{
      padding: 0 0 80px;
      .about-detail-item{
        border-left: 4px solid #e76321;
        margin-top: 60px;
        padding-left: 20px;
        font-size: 36px;
        line-height: 36px;
        color: #e76321;
        font-weight: bold;
      }
      .detail-cont{
        margin-top: 30px;
        padding-right: 22px;
        font-size: 24px;
        line-height: 42px;
        text-align: justify;
        color: #333333;
      }
    }
  }
  @media screen and (max-width: 1300px){
    .about-detail{
      padding: 0 30px;
      .about-detail-cont{
        .about-detail-item{
          margin-top: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .about-detail{
      width: 100%;
      margin-bottom: 20px;
      padding: 0 15px;
      border-radius: 3px;
      .about-detail-cont{
        padding: 0 0 40px;
        .about-detail-item{
          border-left: 2px solid #e76321;
          margin-top: 30px;
          padding-left: 10px;
          font-size: 18px;
          line-height: 18px;
        }
        .detail-cont{
          margin-top: 15px;
          padding-right: 11px;
          font-size: 12px;
          line-height: 21px;
        }
      }
    }
  }
</style>
<style lang="less">
  .detail-cont{
    img,iframe,video{
      max-width: 100%;
    }
  }
</style>
